import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, LogOut } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Shown whenever an admin has impersonated the GeoStays system host to register
 * company-owned properties. Provides a one-click "Exit to Admin" that clears the
 * impersonation flags and returns to the Admin dashboard.
 */
const AdminActingAsHostBanner = () => {
  const navigate = useNavigate();
  const acting = typeof window !== 'undefined' && localStorage.getItem('adminActingAsHost') === '1';
  if (!acting) return null;

  const exit = () => {
    localStorage.removeItem('hostId');
    localStorage.removeItem('hostToken');
    localStorage.removeItem('adminActingAsHost');
    navigate('/admin');
  };

  return (
    <div
      className="bg-emerald-50 border-y border-emerald-200 py-2.5"
      data-testid="admin-acting-banner"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm text-emerald-900">
          <Building2 className="h-4 w-4 text-emerald-700 flex-shrink-0" />
          <span>
            <strong>Admin mode:</strong> Acting as{' '}
            <span className="font-semibold">GeoStays Hospitality Private Limited</span>. Properties
            you register will be listed under the company (PAN auto-verified).
          </span>
        </div>
        <Button
          size="sm"
          variant="outline"
          onClick={exit}
          className="border-emerald-300 text-emerald-800 hover:bg-emerald-100 flex-shrink-0"
          data-testid="admin-acting-exit-btn"
        >
          <LogOut className="h-4 w-4 mr-1.5" /> Exit to Admin
        </Button>
      </div>
    </div>
  );
};

export default AdminActingAsHostBanner;
